// University & course data for ECP Profili Sassari

export const LOGOS = {
  europa: "/logos/europa.png",
  multiversity: "/logos/multiversity.png",
  pegaso: "https://customer-assets.emergentagent.com/job_profili-telematica/artifacts/n5bthhjn_Universita%CC%80_pegaso_-_logo_%28Italy%2C_2025%29.svg.png",
  mercatorum: "https://customer-assets.emergentagent.com/job_profili-telematica/artifacts/hrdwqs56_Unimercatorum_logo.svg.png",
  sanraffaele: "https://customer-assets.emergentagent.com/job_profili-telematica/artifacts/k52ejvlo_Logo_Universita%CC%80_telematica_San_Raffaele.svg.png",
};

export const UNIVERSITIES = [
  {
    id: "pegaso",
    name: "Università Telematica Pegaso",
    short: "Pegaso",
    color: "#E52C65",
    logo: LOGOS.pegaso,
    badge: "MIUR · Anvur",
    tagline: "Tra i più grandi atenei online d'Italia",
    description:
      "Ateneo telematico riconosciuto dal MIUR. Offerta formativa ampia con docenti di prestigio, materiale interattivo e oltre 95 sedi d'esame in Italia.",
    students: "200.000+",
    image:
      "https://images.unsplash.com/photo-1606761568499-6d2451b23c66?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    triennali: [
      "Economia Aziendale (L-18)",
      "Scienze Economiche (L-33)",
      "Ingegneria Civile e Ambientale (L-7)",
      "Ingegneria Informatica (L-8)",
      "Scienze e Tecniche Psicologiche (L-24)",
      "Scienze del Turismo (L-15)",
      "Scienze della Comunicazione (L-20)",
    ],
    magistrali: [
      "Giurisprudenza (LMG/01) · Ciclo Unico 5 anni",
      "Scienze della Formazione Primaria (LM-85 bis) · Ciclo Unico 5 anni",
      "Scienze Economiche (LM-56)",
      "Management dello Sport (LM-47)",
      "Psicologia (LM-51)",
      "Ingegneria Civile (LM-23)",
      "Scienze Pedagogiche (LM-85)",
    ],
    master: [
      "Master in Criminologia",
      "Master in Digital Marketing",
      "Master in HR Management",
      "Master in Nutrizione e Dietologia",
      "Master in Diritto del Lavoro",
      "Master in Project Management",
    ],
  },
  {
    id: "mercatorum",
    name: "Università Mercatorum",
    short: "Mercatorum",
    color: "#C8102E",
    logo: LOGOS.mercatorum,
    badge: "MIUR · Camere di Commercio",
    tagline: "L'università delle imprese italiane",
    description:
      "Università telematica promossa dalle Camere di Commercio italiane. Forte focus su economia, giurisprudenza e scienze applicate alle imprese.",
    students: "60.000+",
    image:
      "https://images.unsplash.com/photo-1497486751825-1233686d5d80?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    triennali: [
      "Economia Aziendale (L-18)",
      "Economia e Commercio (L-33)",
      "Gestione d'Impresa (L-18)",
      "Scienze dell'Educazione (L-19)",
      "Ingegneria Informatica (L-8)",
      "Scienze Politiche (L-36)",
    ],
    magistrali: [
      "Giurisprudenza (LMG/01) · Ciclo Unico 5 anni",
      "Management (LM-77)",
      "Scienze Pedagogiche (LM-85)",
      "Innovazione e Imprenditorialità (LM-77)",
    ],
    master: [
      "Master in Business Administration (MBA)",
      "Master Legale d'Impresa",
      "Master Coordinamento Pedagogico",
      "Master in Food & Beverage Management",
    ],
  },
  {
    id: "sanraffaele",
    name: "Università San Raffaele Roma",
    short: "San Raffaele",
    color: "#0F2C56",
    logo: LOGOS.sanraffaele,
    badge: "MIUR · Sanità & Olistica",
    tagline: "Salute, psicologia e scienze olistiche",
    description:
      "Università telematica con forte vocazione nelle scienze della salute, della nutrizione e della psicologia. Tradizione di eccellenza nella ricerca biomedica.",
    students: "30.000+",
    image:
      "https://images.unsplash.com/photo-1532094349884-543bc11b234d?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
    triennali: [
      "Scienze Motorie (L-22)",
      "Scienze della Nutrizione (L-29)",
      "Psicologia (L-24)",
      "Scienze Infermieristiche (L/SNT1)",
      "Scienze Politiche (L-36)",
    ],
    magistrali: [
      "Psicologia Clinica (LM-51)",
      "Scienze della Nutrizione Umana (LM-61)",
      "Scienze Motorie (LM-67)",
    ],
    master: [
      "Master in Naturopatia",
      "Master in Criminologia Clinica",
      "Master in Scienze Olistiche",
      "Master in Nutrizione Sportiva",
      "Master in Coaching e Counseling",
    ],
  },
];

export const findUniversity = (id) => UNIVERSITIES.find((u) => u.id === id);

export const ALL_COURSES_FLAT = UNIVERSITIES.flatMap((u) => [
  ...u.triennali.map((c) => ({ name: c, level: "Triennale", uni: u.short, uniId: u.id })),
  ...u.magistrali.map((c) => ({ name: c, level: "Magistrale", uni: u.short, uniId: u.id })),
  ...u.master.map((c) => ({ name: c, level: "Master", uni: u.short, uniId: u.id })),
]);

export const EIPASS_CERTS = [
  {
    title: "EIPASS Informatico",
    subtitle: "Passaporto Europeo del Computer",
    desc: "Certifica le competenze digitali secondo standard europei. Valida nei concorsi pubblici e nelle graduatorie scolastiche.",
    points: ["7 moduli teorici e pratici", "Crediti formativi", "Punteggi nelle graduatorie", "Valida in UE"],
  },
  {
    title: "EIPASS Linguistico",
    subtitle: "Inglese B2 · C1 · C2 (ESOL)",
    desc: "Certificazione linguistica riconosciuta dal MIUR. Test ESOL valido per accesso a lauree magistrali, concorsi e Erasmus.",
    points: ["Livelli QCER", "Riconosciuta MIUR", "Valida per concorsi", "Test online o in sede"],
  },
];

export const BENEFITS = [
  {
    icon: "users",
    title: "Tutor dedicato al Polo",
    desc: "Un referente sempre disponibile per accompagnarti dall'iscrizione alla laurea, in presenza e via WhatsApp.",
  },
  {
    icon: "map-pin",
    title: "95 sedi d'esame in Italia",
    desc: "Sostieni gli esami nella sede più comoda, ovunque ti trovi sul territorio nazionale.",
  },
  {
    icon: "badge-percent",
    title: "Convenzioni fino al -50%",
    desc: "Risparmia sull'iscrizione grazie alle convenzioni esclusive del Polo Profili.",
  },
  {
    icon: "award",
    title: "Certificazioni EIPASS",
    desc: "Informatica e lingue inglese B2/C1/C2 incluse nei percorsi formativi.",
  },
  {
    icon: "headphones",
    title: "Supporto prima e dopo",
    desc: "Orientamento gratuito, assistenza burocratica e supporto didattico continuo.",
  },
  {
    icon: "graduation-cap",
    title: "3 Atenei in una sola sede",
    desc: "Pegaso, Mercatorum e San Raffaele: scegli il percorso più adatto a te.",
  },
];
